import Filters from './Filters';
import Results from './Results';


let Desktop = () => {
    return (
        <>
            <Filters />
            <Results />
        </>
    )
}

export default Desktop;